import { render, staticRenderFns } from "./App.vue?vue&type=template&id=796e3c50&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=796e3c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e3c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796e3c50')) {
      api.createRecord('796e3c50', component.options)
    } else {
      api.reload('796e3c50', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=796e3c50&scoped=true&", function () {
      api.rerender('796e3c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/login2/App.vue"
export default component.exports